import { useEffect } from "react";

import { useUiStore } from "@/stores/ui-store";

/** Mirrors the persisted theme onto <html class="dark">. */
export function ThemeEffect() {
  const theme = useUiStore((state) => state.theme);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dark", theme === "dark");
    root.style.colorScheme = theme;
  }, [theme]);

  return null;
}
